// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__Wwd_y","label":"CategoryService_label__2Lp-X","location":"CategoryService_location__3kjP7"};